// extracted by mini-css-extract-plugin
export default {"btn":"SegmentModal_btn__yE1rv","segmentModal":"SegmentModal_segmentModal__SiUxI"};